import React, { useEffect } from 'react';

const JobRedirect = ({ url }) => {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '50vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <p>Redirecting to jobs...</p>
    </div>
  );
};

export default JobRedirect;